import styles from "./styles.module.scss";
import { dailyActivity } from "../../../shared/utils/dailyActivity";
import { useState } from "react";
import Title from "../../Title";

export default function DayByDay() {
  const [activy, setActivy] = useState(0);

  const handleClick = (index: number) => {
    setActivy(index);
  };
  return (
    <div className={styles.background}>
      <div className="container">
        <section className={styles.dayByDay}>
          <Title color="#fff">O que a Kenzie oferece para você?</Title>
          <p className={styles.subTitle}>
            Estude programação na <strong>Kenzie Academy</strong> e comece a
            trilhar o caminho para o sucesso profissional!
          </p>
          <p className={styles.subTitle}>
            Com <strong>horários flexíveis</strong> de estudo, você pode
            aprender programação de acordo com a sua disponibilidade, sem
            comprometer sua rotina diária.
          </p>
          <p className={styles.subTitle}>
            Veja como funciona a jornada de aprendizado:
          </p>

          <div className={styles.content}>
            <nav className={styles.menu}>
              <button
                type="button"
                className={activy === 0 ? styles.active : ""}
                onClick={() => handleClick(0)}
              >
                Aula
              </button>
              <button
                type="button"
                className={activy === 1 ? styles.active : ""}
                onClick={() => handleClick(1)}
              >
                Projetos
              </button>
              <button
                type="button"
                className={activy === 2 ? styles.active : ""}
                onClick={() => handleClick(2)}
              >
                Soft skills
              </button>
            </nav>

            <article>
              <h3>{dailyActivity[activy].title}</h3>
              <p className={styles.time}>{dailyActivity[activy].time}</p>   
              {dailyActivity[activy].paragraphs.map((p, index) => (
                <p key={p + index} className={styles.paragraph}>
                  {p}
                </p>
              ))}
            </article>
          </div>
        </section>
      </div>
    </div>
  );
}
